package horcrux.frontend.common.views.components.containers

import mui.material.Stack
import mui.material.StackDirection
import mui.material.StackProps
import mui.system.responsive
import react.FC

external interface VStackProps : StackProps

val VStack = FC<VStackProps> { props ->
    Stack {
        +props
        this.direction = responsive(StackDirection.column)
    }
}
